import React, { useState, useEffect } from 'react';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { formatNumber } from '@utils/helper';
import { Row, Col, Spin } from 'antd';
import { Treemap } from '@ant-design/plots';
import RelativeDate from '@common/RelativeDate';
import SumTable from '@common/SumTable';

function ProductQuantityCategory() {
  const [tableData, setTableData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const { isLoading, mutate } = useMutation(() => {
    return request.get(`v1/product-meta/category-quantities`);
  },
    {
      onSuccess: (response) => {
        const tableData = response.data.map(x => {
          const result = {
            categoryId: x.categoryId,
            name: x.name || 'Khác',
            value: x.qty || 0
          }
          return result;
        })
        setTableData(tableData);
        // const treeData = response.data.map(t => ({
        //   name: t.name,
        //   value: t.qty,
        // }))
        setChartData({
          name: 'root',
          children: tableData
        });
      },
    })
  const onChangeDate = (type, timeRange) => {
    // getSaleQuantity({ timeRange });
  }
  useEffect(() => {
    mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const columns = [
    {
      title: 'id',
      dataIndex: 'categoryId',
    },
    {
      title: 'Nhóm',
      dataIndex: 'name',
    },
    {
      title: 'Số lượng',
      dataIndex: 'value',
      align: 'right',
      render: formatNumber,
      sorter: (a, b) => a.value - b.value,
    },
  ]
  const numberColumns = ['value'];
  return (<>
    <Row gutter={16}>
      <Col sm={14}>
        <h2>Tồn theo nhóm</h2>
      </Col>
      <Col sm={10}>
        <RelativeDate onChange={onChangeDate} />
      </Col>
    </Row>
    <Spin spinning={isLoading}>
      <Row gutter={16} style={{ marginTop: '2rem' }}>
        <Treemap data={chartData} colorField="name" />
      </Row>
      <Row gutter={16} style={{ marginTop: '2rem' }}>
        <Col sm={24}>
          <SumTable
            numberColumns={numberColumns}
            pagination={false}
            dataSource={tableData}
            columns={columns}
            rowKey="categoryId" />
        </Col>
      </Row>
    </Spin>
  </>)
}

ProductQuantityCategory.propTypes = {
};

ProductQuantityCategory.defaultProps = {
};

export default ProductQuantityCategory;
